<template>
  <v-row>
    <v-col cols="6">
      <!-- 顧客名 -->
      <SelectCustomerName v-model="inputedValue.supplierName" />
    </v-col>
    <v-col cols="6"> </v-col>
  </v-row>
</template>

<script>
import { SelectCustomerName } from '@/components/items/Selectboxes'

export default {
  components: {
    SelectCustomerName
  },
  props: {
    value: {}
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
